import { SkeletonText } from '@tlx/atlas';
import { OnboardingStageTitle, OnboardingStageContent } from '@tlx/beehive-shared';

export function OnboardingStageSkeleton() {
    return (
        <>
            <OnboardingStageTitle>
                <SkeletonText width="200px" />
            </OnboardingStageTitle>
            <OnboardingStageContent className="atl-flex atl-flex-col atl-gap-24">
                <SkeletonText className="atl-w-full" />
                <SkeletonText className="atl-w-full" />
                <SkeletonText className="atl-w-full" />
            </OnboardingStageContent>
        </>
    );
}
